import { render, staticRenderFns } from "./Rep.vue?vue&type=template&id=24c847eb&scoped=true&"
import script from "./Rep.vue?vue&type=script&lang=ts&"
export * from "./Rep.vue?vue&type=script&lang=ts&"
import style0 from "./Rep.vue?vue&type=style&index=0&id=24c847eb&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24c847eb",
  null
  
)

export default component.exports